module.exports = __webpack_public_path__ + "img/type2.ad257231.png";